// extracted by mini-css-extract-plugin
export default {"color-pill":"styles_color-pill__2jBKe"};